export default "__VITE_ASSET__BbA2sDZv__"